import React from 'react';
import styles from './Social2.module.css';

import asset1 from '../../../assets/social2-asset-1.png';
import asset2 from '../../../assets/safe2-asset-4.png';
import asset3 from '../../../assets/safe2-asset-2.png';

import asset4 from '../../../assets/orange_poly.png';
import asset5 from '../../../assets/green_poly.png';
const Social2 = () => {
  return (
    <section className={styles.social2Container}>
        <img src={asset1} alt="Asset 1" className={styles.rightImage} />
        <img src={asset2} alt="Asset 2" className={styles.innerLeftImage} />
        <img src={asset3} alt="Asset 3" className={styles.leftImage} />
        <img src={asset4} alt="Asset 4" className={styles.orangePoly} />
        <img src={asset5} alt="Asset 5" className={styles.greenPoly} />
      <h2 className={styles.topText}>Community based vetting options</h2>
      <h2 className={styles.midText}>A double verification system keeps our users safe<br/>from any kind of malicious intent</h2>
    </section>
  );
};

export default Social2;
